/* Derby — Build Your Fit (2026-09-14).
   Two-step outfit builder. Selecting a product opens its size row; a look is only completable
   when BOTH pieces have an in-stock variant chosen, so nobody can build something unbuyable.
   Pricing math mirrors the live Buy 1 Get 1 Free mechanic (cheaper of the two is free) and is
   driven by the data-offer key written by snippets/derby-offer-config.liquid — if the offer is
   'none' the saving line simply does not appear. Adds both lines in ONE /cart/add.js call. */
(function () {
  if (window.__derbyFitBuilder) return;
  window.__derbyFitBuilder = 1;

  function money(paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function init(root) {
    var offer = root.getAttribute('data-offer') || 'none';
    var state = { top: null, bottom: null };

    var panels = {
      top: root.querySelector('.dfb__panel[data-slot="top"]'),
      bottom: root.querySelector('.dfb__panel[data-slot="bottom"]')
    };
    var summary = root.querySelector('.dfb__summary');
    var linesEl = root.querySelector('.dfb__lines');
    var wasEl = root.querySelector('.dfb__was');
    var nowEl = root.querySelector('.dfb__now');
    var saveEl = root.querySelector('.dfb__save');
    var addBtn = root.querySelector('.dfb__add');
    var errEl = root.querySelector('.dfb__err');

    function setPanel(slot, imgUrl, alt) {
      var p = panels[slot];
      if (!p) return;
      var img = p.querySelector('.dfb__img');
      img.classList.remove('is-in');
      var load = new Image();
      load.onload = function () {
        img.src = imgUrl;
        img.alt = alt || '';
        img.hidden = false;
        p.classList.add('is-filled');
        requestAnimationFrame(function () { img.classList.add('is-in'); });
      };
      load.src = imgUrl;
    }

    function openStep(slot) {
      root.querySelectorAll('.dfb__step').forEach(function (s) {
        var on = s.getAttribute('data-step') === slot;
        s.classList.toggle('is-open', on);
        var h = s.querySelector('.dfb__stephead');
        if (h) h.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    function render() {
      var t = state.top, b = state.bottom;
      var any = t || b;
      summary.hidden = !any;
      if (!any) return;

      linesEl.innerHTML = '';
      var chosen = [t, b].filter(Boolean);
      var freeOne = null;
      if (offer !== 'none' && t && b) {
        freeOne = (t.price <= b.price) ? t : b;
      }
      chosen.forEach(function (it) {
        var row = document.createElement('div');
        row.className = 'dfb__line' + (it === freeOne ? ' is-free' : '');
        row.innerHTML = '<em>' + it.title + (it.sizeLabel ? ' · ' + it.sizeLabel : '') + '</em>' +
          '<span><strong>' + money(it.price) + '</strong>' +
          (it === freeOne ? '<span class="dfb__freetag">Free</span>' : '') + '</span>';
        linesEl.appendChild(row);
      });

      var gross = chosen.reduce(function (s, i) { return s + i.price; }, 0);
      var net = freeOne ? gross - freeOne.price : gross;
      wasEl.textContent = (net !== gross) ? money(gross) : '';
      nowEl.textContent = money(net);
      if (freeOne) {
        saveEl.hidden = false;
        saveEl.textContent = 'You save ' + money(gross - net) + ' — your lower-priced piece is free.';
      } else {
        saveEl.hidden = true;
      }

      var ready = !!(t && t.variantId && b && b.variantId);
      addBtn.disabled = !ready;
      addBtn.textContent = ready ? 'Add both to cart'
        : (!t ? 'Choose your top' : (!t.variantId ? 'Select a size for your top'
        : (!b ? 'Choose your bottom' : 'Select a size for your bottom')));
    }

    function buildSizes(step, item, card) {
      var wrap = step.querySelector('.dfb__sizes');
      var row = step.querySelector('.dfb__sizerow');
      row.innerHTML = '';
      var variants = [];
      try { variants = JSON.parse(card.getAttribute('data-variants')); } catch (e) { variants = []; }
      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dfb__size';
        b.textContent = v.t;
        b.setAttribute('aria-pressed', 'false');
        b.disabled = !v.a;
        if (!v.a) b.title = 'Sold out';
        b.addEventListener('click', function () {
          row.querySelectorAll('.dfb__size').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          item.variantId = v.id;
          item.sizeLabel = v.t;
          step.classList.add('is-done');
          var chosenEl = step.querySelector('.dfb__chosen');
          if (chosenEl) chosenEl.textContent = item.title + ' · ' + v.t;
          render();
          if (item.slot === 'top' && !state.bottom) openStep('bottom');
        });
        row.appendChild(b);
      });
      wrap.hidden = variants.length === 0;
    }

    root.querySelectorAll('.dfb__step').forEach(function (step) {
      var slot = step.getAttribute('data-step');

      var head = step.querySelector('.dfb__stephead');
      if (head) head.addEventListener('click', function () {
        openStep(step.classList.contains('is-open') ? '' : slot);
      });

      step.querySelectorAll('.dfb__card').forEach(function (card) {
        card.addEventListener('click', function () {
          step.querySelectorAll('.dfb__card').forEach(function (c) { c.setAttribute('aria-selected', 'false'); });
          card.setAttribute('aria-selected', 'true');

          var item = {
            slot: slot,
            pid: card.getAttribute('data-pid'),
            title: card.getAttribute('data-title'),
            price: parseInt(card.getAttribute('data-price'), 10) || 0,
            img: card.getAttribute('data-img'),
            url: card.getAttribute('data-url'),
            variantId: null,
            sizeLabel: null
          };
          state[slot] = item;
          step.classList.remove('is-done');
          var chosenEl = step.querySelector('.dfb__chosen');
          if (chosenEl) chosenEl.textContent = item.title;
          setPanel(slot, item.img, item.title);
          buildSizes(step, item, card);
          render();
        });
      });
    });

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      errEl.hidden = true;
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: state.top.variantId, quantity: 1 },
            { id: state.bottom.variantId, quantity: 1 }
          ]
        })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
        return r.json();
      }).then(function () {
        addBtn.textContent = 'Added — opening cart…';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.location.href = '/cart';
      }).catch(function (e) {
        addBtn.disabled = false;
        addBtn.textContent = original;
        errEl.hidden = false;
        errEl.textContent = e.message || 'Something went wrong. Please try again.';
      });
    });

    render();
  }

  /* Deep-link support: /pages/build-your-fit?top=<handle> or ?bottom=<handle>.
     This is what makes the PDP entry point worth having — arriving at an empty builder from a
     product you were already looking at is a dead end, so we preselect that piece and open the
     step the shopper still has to fill. */
  function applyDeepLink(root) {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    ['top', 'bottom'].forEach(function (slot) {
      var handle = params.get(slot);
      if (!handle) return;
      var step = root.querySelector('.dfb__step[data-step="' + slot + '"]');
      if (!step) return;
      var card = step.querySelector('.dfb__card[data-handle="' + handle.replace(/"/g, '') + '"]');
      if (!card) return;
      card.click();
      card.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
    // open whichever step is still empty so the next action is obvious
    if (params.get('top') && !params.get('bottom')) {
      var b = root.querySelector('.dfb__step[data-step="bottom"] .dfb__stephead');
      if (b && b.getAttribute('aria-expanded') !== 'true') b.click();
    } else if (params.get('bottom') && !params.get('top')) {
      var t = root.querySelector('.dfb__step[data-step="top"] .dfb__stephead');
      if (t && t.getAttribute('aria-expanded') !== 'true') t.click();
    }
  }

  function boot() {
    document.querySelectorAll('.dfb').forEach(function (root) {
      init(root);
      applyDeepLink(root);
    });
  }
  document.readyState !== 'loading' ? boot() : document.addEventListener('DOMContentLoaded', boot);
})();
